/* eslint-disable no-unused-vars */
import 'lazysizes';
import { gsap } from 'gsap';
import InfiniteScroll from './components/infiniteScroll';
import Modal from './components/modal';
import Slider from './components/slider';
import Loader from './components/loader';
import Split from './components/split';
import Toggle from './components/toggle';import Cart from './components/cart';
import VideoModal from "./components/videoModal";
import ScrollTriggerGsap from './components/scrollTriggerGsap';
// import Cursor from './components/cursor';
import Search from './components/search';
import Menu from './components/menu';
import Billing from './components/billing';
import NavigationHover from './components/navigationHover';

const infiniteScroll = new InfiniteScroll();
const loader = new Loader();
const modal = new Modal();
const menu = new Menu();
const split = new Split();
const toggle = new Toggle();
const cart = new Cart();
const videoModal = new VideoModal();
const billing = new Billing();
const scrollTriggerGsap = new ScrollTriggerGsap();
// const cursor = new Cursor();
const search = new Search();
const navigationHover = new NavigationHover();

const sliderGallery = new Slider('.js-slider-gallery', {
	direction: 'horizontal',
	loop: false,
	effect: 'slide',
	speed: 1000,
	autoHeight: false,
	parallax: true,
	autoplay: false,
	slidesPerView: 1.5,
	spaceBetween: 24,
	navigationType: 'arrows', // 'arrows', 'bullets', 'both', 'none'
	paginationType: 'progressbar', // 'bullets' | 'fraction' | 'progressbar' | 'custom' | false
	breakpoints: {
		// when window width is >= xl
		1440: {
			speed: 1000,
			spaceBetween: 24,
			slidesPerView: 4,
		},
	},
});

var $body = jQuery('body'),
    scrollClass = 'body-scrolled',
    activateAtY = 70;

function deactivateScroll() {
    if (!$body.hasClass(scrollClass)) {
        $body.addClass(scrollClass);
    }
}

function activateScroll() {
    if ($body.hasClass(scrollClass)) {
        $body.removeClass(scrollClass);
    }
}

jQuery(window).scroll(function() {
    if(jQuery(window).scrollTop() > activateAtY) {
        deactivateScroll();
    } else {
        activateScroll();
    }
});

// Attiva modale per richiesta informazioni
jQuery(function($){
  // Apri la modale
  $('.button_medici_form').on('click', function(e){
    e.preventDefault();
    $('.modal-form_wrapper').addClass('is-active');
  });

  // Chiudi la modale al click sul pulsante di chiusura
  $('.modal-form__close').on('click', function(e){
    e.preventDefault();
    $('.modal-form_wrapper').removeClass('is-active');
  });

  // Chiudi la modale alla pressione del tasto Esc
  $(document).on('keydown', function(e){
    if ( e.key === 'Escape' || e.keyCode === 27 ) {
      $('.modal-form_wrapper').removeClass('is-active');
    }
  });
});
